import { CopyOutlined, PauseCircleOutlined, PlayCircleOutlined, RightOutlined } from '@ant-design/icons';
import { Col, Divider, Form, Input, message, Modal, Progress, Row, Spin } from 'antd';
import React, { forwardRef, Fragment, useEffect, useImperativeHandle, useRef, useState } from 'react';
import './PlayVideo.css';
import type { ForwardRefType } from './type';

// import { v4 as uuidv4 } from 'uuid';
// const CryptoJS = require("crypto-js");

const { Configuration, OpenAIApi } = require("openai");
let globalChatGptApiKey = '' //'YOUR_API_KEY';
// const apiKey = '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' //'YOUR_API_KEY';
// const configuration = new Configuration({
//   apiKey: apiKey,
// });
// const openai = new OpenAIApi(configuration);


type LastPlaybackPositionTYPE = {
  videoName: string,
  subName: string,
  lastPlaySubindex: string,
  subTitleSowModel: string,
  chatGptApiKey: string,
  addTime: number,
  [key: string]: any
}


// import copy from 'copy-to-clipboard';

// const videoPath = require('./assets/video/S1～01.mp4');
// const textTrackPath = require('./assets/video/S1～01.vtt');

type PropsType = {
  showGuide: () => void
  changeIsVideoPlaying: (data: boolean) => void
  singleSentencePattern: boolean
  videoSrc?: string
  textTrack?: string
  screenOrientation: boolean
}
// type ForwardRefType = {
//   isVideoPlaying: boolean
//   handleVideoPlay(flag: string): void
//   singleSentencePatternChangedHandle(bool: boolean): void
//   showModal(): void
//   subHidenType: {
//     text0Show: boolean
//     text1Show: boolean
//     type: string
//   }
//   videoTimeLine: number
// }

const PlayVideo = forwardRef<ForwardRefType, PropsType>((
  props: PropsType,
  ref
) => {
  // 当前大字幕
  const wideSubTitleline = useRef<string>(
    `
      #052b5c -0.3rem 0.2rem 1rem,
      #052b5c -0.3rem -0.2rem 1rem,
      #052b5c 0.3rem -0.2rem 1rem,
      #052b5c 0.3rem 0.2rem 1rem,
    `
  )
  // 其他小字幕
  const thinSubTitleline = useRef<string>(
    `
      #052b5c -0.2rem -0.2rem 0.5rem,
      #052b5c -0.2rem 0.2rem 0.5rem,
      #052b5c 0.2rem -0.2rem 0.5rem,
      #052b5c 0.2rem 0.2rem 0.5rem
    `
  )

  // 复制消息弹框
  const [messageApi, contextHolder] = message.useMessage();
  // 复制消息弹框
  // const [api, contextHolder] = notification.useNotification();
  // const { showGuide } = props;

  // 键盘监听
  const keyBordEven = () => {
    // 媒体功能键监听
    navigator.mediaSession.setActionHandler('previoustrack', function () {
      // User hit "Previous Track" key.
      handleVideoPlay('Left')
    });

    navigator.mediaSession.setActionHandler('nexttrack', function () {
      // User hit "Next Track" key.
      handleVideoPlay('Right')
    });
    navigator.mediaSession.setActionHandler('play', function () {
      // User hit "Play" key.
      handleVideoPlay('Play')
    });

    navigator.mediaSession.setActionHandler('pause', function () {
      // User hit "Pause" key.
      handleVideoPlay('Pause')
    });
    // window.addEventListener("keydown", function (e) {
    //   if (e.code === "Space") {
    //     e.preventDefault();
    //   }
    // });
    window.addEventListener('keyup', function (event) {
      // 禁止默认事件
      event.preventDefault()
      var key = event.key; // 获取抬起的键的字符
      var keyCode = event.keyCode; // 获取抬起的键的键码
      console.log('key :', key, keyCode);
      //       MediaTrackPrevious 177
      // MediaPlayPause 179
      // MediaTrackNext 176
      // 在这里根据抬起的按键进行相应的处理
      if (key === 'Enter') {
        // 处理抬起回车键的逻辑
        // if (!videoNode?.paused) {
        //   handleVideoPlay('Pause')
        // } else {
        //   handleVideoPlay('Play')
        // }
      } else if (keyCode === 27) {
        // 处理抬起ESC键的逻辑

      } else if (keyCode === 192) {
        // console.log('videoNode :', [videoNode?.paused]);
        // 处理抬起`键的逻辑
        if (!videoNode?.paused) {
          handleVideoPlay('Pause')
        } else {
          handleVideoPlay('Play')
        }
      } else if (keyCode === 32 || keyCode === 179 || key === 'MediaPlayPause') {
        // 空格
        if (!videoNode?.paused) {
          handleVideoPlay('Pause')
        } else {
          handleVideoPlay('Play')
        }
      } else if (keyCode === 38 || keyCode === 177 || key === 'MediaTrackPrevious') {
        // 上
        handleVideoPlay('Left')
      } else if (keyCode === 40 || keyCode === 176 || key === 'MediaTrackNext') {
        // 下
        handleVideoPlay('Right')
      } else if (keyCode === 37) {
        // 左
      } else if (keyCode === 39) {
        // 右
        showModal()
      }
    });

  }
  // let globelSelectTimer = useRef<NodeJS.Timer | null>()
  // 字幕定位定时器
  const ScreenOrientationTimer = useRef<NodeJS.Timer | null>()
  // 生命周期
  useEffect(() => {
    document?.addEventListener("visibilitychange", function () {
      if (document.visibilityState === 'visible') {
        // 文档变为可见状态
        console.log("文档变为可见状态");
      } else {
        // 文档变为不可见状态
        console.log("文档变为不可见状态,存储播放数据");
        // 获取上次localStrong 最新存储结果 再次合并 存储
        const { videoName, subName, lastPlaySubindex } = lastPlaybackPosition?.current
        if (videoName && subName && lastPlaySubindex) {
          window?.localStorage?.setItem(`${videoName}-${subName}`, JSON.stringify(lastPlaybackPosition?.current))
          console.log(
            'localStorage设置播放进度数据 :',
            videoName,
            subName,
            lastPlaySubindex,
            lastPlaybackPosition?.current
          );

        }
      }
    });
    // 键盘按键
    keyBordEven()

    //获取文本元素
    const myText = document?.getElementById("word");

    //添加点击事件
    myText?.addEventListener("click", function () {
      const range = document?.createRange();
      range?.selectNode(this);
      window?.getSelection()?.removeAllRanges()
      window?.getSelection()?.addRange(range);
      // if (globelSelectTimer?.current)window?.clearTimeout(globelSelectTimer?.current)
      // globelSelectTimer.current = setTimeout(() => {
      //   window?.getSelection()?.removeAllRanges()
      // },1000) 
    });
    if (!(videoSrc && subSrc)) {
      setIsModalOpen(true);
    }
    // let myHeaders = new Headers({
    //   'Access-Control-Allow-Origin': '*',
    //   // 'Content-Type': 'text/plain'
    // });
    // fetch(
    //   "sg/text?fr=default&keyword=cat&transfrom=auto&transto=en&model=general", {
    //   // method: 'GET',
    //   headers: myHeaders,
    //   mode: 'cors'
    // })?.then(res => {
    //   console.log('123123',res);
    // })

    // 窗口尺寸变化
    const changeVideoSize = () => {

      console.log('subTitlesLong :', subTitlesLong?.clientHeight, videoNode?.clientHeight, videoNode?.clientHeight / subTitlesLong?.clientHeight * 100);
      // 横屏
      if (subTitlesLong?.clientHeight === videoNode?.clientHeight) {

        setMaskPercent(60)
      } else {

        setMaskPercent(videoNode?.clientHeight / subTitlesLong?.clientHeight * 100)
      }

      // setIsTransLate([false, ''])
      // window.screen.availHeight / window.screen.availWidth
      // console.log('window.screen.availHeight / window.screen.availWidth :', window.screen.availHeight, window.screen.availWidth, Math?.round(window.screen.availHeight / 16));
      // // if (window.screen.availHeight / window.screen.availWidth >= 9 / 16) {

      //   setvideosize({
      //     width: Math?.round(window.screen.availWidth / 16) + 'rem',
      //     height: '90vh'
      //   })
      // } else if (window.screen.availHeight / window.screen.availWidth < 9 / 16) {
      //   setvideosize({
      //     // width: '100%',
      //     width: '100vw',
      //     height: 'calc('+ Math?.round(window.screen.availHeight / 16) + 'rem - 10rem)'
      //   })
      // }
      // } else {
      //   setvideosize({
      //     width: 'auto',
      //     height: '100%'
      //   })

      // }
    }
    changeVideoSize()

    // 监听窗口尺寸改变事件
    window.onresize = changeVideoSize

    // 监听视频尺寸变化
    let ResizeObserverObj: ResizeObserver | null = new ResizeObserver(entries => {
      // for (const entry of entries) {
      // const cr = entry.contentRect;
      const cr = entries?.[0]?.contentRect;
      setSubBacksize({
        width: cr.width,
        height: cr.height
      })

      // }
      // setSubBacksize({
      //   width: window?.innerWidth,
      //   height: window.innerHeight
      // })
      // 尺寸改签定位字幕
      // if (videoNode?.currentTime) videoNode.currentTime = syncSubTitlesArr?.current?.[parseInt(activeSubRef?.current)]?.startTime


      console.log('活跃字幕:', /* activeSub, '---', */
        activeSubRef?.current, '---',
        lastPlaybackPosition?.current?.lastPlaySubindex, '---',
      );
      // 尺寸变化自动定位字幕
      let index = parseInt(lastPlaybackPosition.current?.lastPlaySubindex)
      ScreenOrientationTimer.current && clearTimeout(ScreenOrientationTimer.current)
      ScreenOrientationTimer.current = setTimeout(() => {

        subTitlesLong?.children?.[
          (index < syncSubTitlesArr.current?.length - 1 && index >= 1) ?
            (
              (window.orientation === 0 || window.orientation === 180) ?
                index + 1 :
                index - 1
            )
            :
            index
        ]?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        })
      }, 100);
    });
    ResizeObserverObj.observe(videoNode)
    // 监听文本轨道变化事件
    //     videoNode.textTracks[0].oncuechange = (e: any) => {
    //
    //       const { videoName, subName, lastPlaySubindex } = lastPlaybackPosition?.current
    //       if (videoName && subName && lastPlaySubindex) {
    //         window?.localStorage?.setItem(`${videoName}-${subName}`, JSON.stringify(lastPlaybackPosition?.current))
    //       }
    //
    //       if (subEndPlay?.current && !e?.currentTarget?.activeCues?.length) {
    //         videoNode?.pause()
    //         if (subEndLoop.current) {
    //           numTimeout.current = null
    //           numTimeout.current = setTimeout(() => {
    //             setSubTitlesLongOnDoubleClickHandle(null, lastPlaybackPosition?.current?.lastPlaySubindex)
    //             // eslint-disable-next-line @typescript-eslint/no-unused-vars
    //             let timeNum: any = setTimeout(() => {
    //               videoNode?.play()
    //               timeNum = null
    //             }, 0)
    //           }, 2000)
    //         }
    //       }
    //       const activeCuesIndex: string = e?.currentTarget?.activeCues?.[0]?.id
    //
    //       if (e?.currentTarget?.activeCues?.length) {
    //         setActiveSub(activeCuesIndex)
    //         activeSubRef.current = activeCuesIndex
    //         lastPlaybackPosition.current = { ...lastPlaybackPosition?.current, lastPlaySubindex: activeCuesIndex }
    //       }
    //
    //       let index = parseInt(activeCuesIndex)
    //       subTitlesLong?.children?.[
    //         index < syncSubTitlesArr.current?.length - 1 && index >= 1 ?
    //           window.orientation === 0 || window.orientation === 180 ?
    //             index + 1 :
    //             index - 1
    //           :
    //           index
    //       ]?.scrollIntoView({
    //         behavior: 'smooth',
    //         block: 'center',
    //         inline: 'center',
    //       })
    //     }
    return () => {
      ResizeObserverObj = null
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  //--------------------------------------节点元素

  // 视频元素
  let videoNode: HTMLVideoElement
  const SetvideoRef = (e: HTMLVideoElement) => {
    if (e) videoNode = e;
    // setVideoNodeClientHeight(videoNode?.clientHeight ?? 0)
  }

  // 字幕元素
  let subTitlesLong: any
  const setSubTitlesLong = (e: any) => {
    if (e) subTitlesLong = e;
  }
  // // 进度条元素
  // let progressRef: any
  // const setProgressRef = (e: any) => {
  //   if (e) progressRef = e;
  // }
  // 字幕元素
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  let textTrackRef: any
  const setTextTrackRef = (e: any) => {
    if (e) textTrackRef = e;
  }

  // 全屏弹幕父级元素
  // let fullSub: any
  const SetFullSubRef = (e: any) => {
    // fullSub = e;
  }
  // 模式选择
  // let selectRef: any
  const setSelectRef = (e: any) => {
    // selectRef = e;
  }
  const [/* selectValue */, setSelectValue] = useState('3')
  // // 弹窗元素
  // let modalRef: any
  // const SetModalRef = (e: any) => {
  //   modalRef = e;
  // }


  //---------------------------------state数据
  // 视频遮罩尺寸
  // const [videosize, setvideosize] = useState({
  //   width: '100vw',
  //   // height: 'calc(' + Math?.round(window.screen.availHeight / 16) + 'rem' + '-4.5rem)'
  //   height: '90vh'
  // })

  // 视频高度 视频宽度
  const [subBacksize, setSubBacksize] = useState({
    width: 0,
    height: 0
  })

  // 字幕背景遮罩尺寸
  const [maskPercent, setMaskPercent] = useState(0)
  // useEffect(() => {
  // setMaskPercent(subTitlesLong?.clientHeight / subBacksize?.height)

  // return () => { }
  // }, [subBacksize])

  // 字幕内容数组
  const [subTitlesArr, setsubTitlesArr] = useState<any[]>([])
  const syncSubTitlesArr = useRef<any[]>([])

  // 同步,不销毁,活跃字幕
  const activeSubRef = useRef<string>('0')



  //---------------------------------------事件
  //弹框管理
  // const [isTransLate, setIsTransLate] = useState<[boolean, string, string?]>([false, '']);
  //等待遮罩管理
  const [showBoard, setWaitBoard] = useState<boolean>(false);
  //翻译结果
  // const [transLateContent, setTransLateContent] = useState<string>('');
  // 网络查词超时定时器
  let netTranslateTimeout = useRef<NodeJS.Timer | null>(null);
  // 全局翻译结果弹窗
  const confirmTimeout_gloabel = useRef<NodeJS.Timer | null>()
  // // 文字选中效果
  const netTranslate = async (str?: string) => {
    // const selectString = window?.getSelection()?.toString() ?? ''
    if (!(/* /\s/.test(selectString) || */ str)) return
    // window?.getSelection()?.removeAllRanges()

    //
    // navigator?.clipboard?.writeText(selectString)?.then(() => {
    // alert('复制成功')
    // messageApi.open({
    //   type: 'success',
    //   content: '复制成功',
    // });
    // api.info({
    //   message: `复制成功`,
    //   // description:'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
    //   placement: 'bottom',
    // });
    // })?.catch(() => {
    // alert('复制失败')
    // messageApi.open({
    //   type: 'error',
    //   content: '复制失败',
    // });
    // api.info({
    //   message: `复制失败`,
    //   // description:'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
    //   placement: 'bottom',
    // });
    // })
    // window?.getSelection()?.empty()
    // window?.getSelection()?.removeAllRanges()
    videoNode?.pause()
    // if (selectString?.includes(' ')) {








    // // 要翻译的文本
    // let text = selectString//"Hello, world!";

    // // API密钥和应用ID，需要在有道开发者中心注册并获取
    // let appKey = '0bbc861da91814d1'//"your app key";
    // let appSecret = 'aT3nJowADbBbNvOSZIZDpBHwpR1kB96V'//"your app secret";
    // let salt: string = (new Date()).getTime()?.toString()
    // let time = Math.round(new Date().getTime() / 1000)
    // // 发送POST请求给有道翻译API
    // // fetch("https://openapi.youdao.com/api", {
    // const truncate = (q: string ) => {
    //   let len = q.length;
    //   if (len <= 20) return q;
    //   return q.substring(0, 10) + len + q.substring(len - 10, len);
    // }
    // fetch("/ydapi", {
    //   method: "POST",
    //   headers: {
    //     // "Content-Type": "application/x-www-form-urlencoded",
    //     // 'Content-Type': 'application/json', // 请求头中的Content-Type必须指定为application/json
    //     'Access-Control-Allow-Origin': '*' // 添加CORS头信息
    //   },
    //   body: JSON.stringify({
    //     q: text,//	text	待翻译文本	True	必须是UTF-8编码
    //     from: 'auto',//	text	源语言	True	参考下方 支持语言 (可设置为auto)
    //     to: 'zh-CHS',//	text	目标语言	True	参考下方 支持语言
    //     appKey: appKey,//	text	应用ID	True	可在应用管理 查看
    //     salt: salt,//	text	UUID	True	uuid，唯一通用识别码
    //     sign: CryptoJS?.SHA256(appKey + truncate(text) + salt + time + appSecret)?.toString(CryptoJS.enc.Hex),//	text	签名	True	sha256(应用ID+input+salt+curtime+应用密钥)
    //     signType: 'v3',//	text	签名类型	True	v3
    //     curtime: `${time}`,//	text	当前UTC时间戳(秒)	true	TimeStamp
    //   }),
    //   // "q=" + text + "&from=en&to=zh_CHS&appKey=" + appKey + "&salt=1&sign=" + CryptoJS?.SHA256(appKey + text + 1 + uuidv4() + appSecret)?.toString() // 计算签名
    // })
    //   ?.then(response => response?.json()) // 将响应解析为JSON对象
    //   ?.then(data => {
    //     console?.log(data?.translation);
    //     setIsTransLate([true, selectString, data])
    //   }); // 输出翻译结果

    let prompt: string = ''
    if (/* /\s/.test(selectString) || */ str && /\s/.test(str)) {
      // 句子
      prompt = `“${str}”翻译这句话，并且拆解句子各部分语法结构分析，还有英文简易同义词替换后的例句，用中文回答`//'Hello, GPT-3!';
    } else if (str) {
      // 单词
      prompt = `“${str}”请说明这个单词的翻译.在国内英语考试等级会出现.发音.词根.搭配.例句等五个内容，用中文回答`//'Hello, GPT-3!';
    }
    // const apiKey = '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' //'YOUR_API_KEY';
    if (globalChatGptApiKey && str && /\s/.test(str)) {
      // 等待遮罩
      setWaitBoard(true)

      if (netTranslateTimeout?.current) clearTimeout(netTranslateTimeout?.current)
      netTranslateTimeout.current = setTimeout(() => {
        setWaitBoard(false)
      }, 5000)

      console.log('lastPlaybackPosition.current.chatGptApiKey :', lastPlaybackPosition.current.chatGptApiKey, globalChatGptApiKey);

      const configuration = new Configuration({
        apiKey: globalChatGptApiKey,
      });
      const openai = new OpenAIApi(configuration);
      openai?.createChatCompletion({
        model: "gpt-3.5-turbo",
        messages: [
          { role: "user", content: prompt/* "Hello world" */ },
          // { role: "user", content: prompt2/* "Hello world" */ }
        ],
      })?.then((chatCompletion: any) => {

        // setTransLateContent(chatCompletion?.data?.choices?.[0]?.message?.content)
        // if (selectString) {
        //   setIsTransLate([true, selectString, ''])
        // } else if (str) {
        //   setIsTransLate([true, str, ''])

        // }
        // 隐藏等待遮罩
        setWaitBoard(false)
        //翻译结果
        // setTransLateContent(() => {
        //   // setTimeout(() => {

        //   // }, 0);
        //   return chatCompletion?.data?.choices?.[0]?.message?.content
        // })

        if (confirmTimeout_gloabel?.current) window.clearTimeout(confirmTimeout_gloabel?.current)
        // 翻译结果
        confirmTimeout_gloabel.current = setTimeout(() => {

          /* const reaslt = */
          // window?.confirm(/* '复制原文吗?\n\n' +  */chatCompletion?.data?.choices?.[0]?.message?.content)
          setIsShowAItranslateContent(true)
          setShowAItranslateContent(chatCompletion?.data?.choices?.[0]?.message?.content)
          // if (reaslt) {
          //   navigator?.clipboard?.writeText(selectString || str || '')?.then(() => {
          //     messageApi?.open({
          //       type: 'success',
          //       content: '复制句子成功 ' + (selectString || str),
          //     });
          //   })?.catch(() => {
          //   })
          // }
        }, 0);
      })
    }



    // fetch('/ydapi/v1/engines/davinci-codex/completions', {
    // fetch('/ydapi/v1/chat/completions', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Bearer ${apiKey}`,
    //   },
    //   body: JSON.stringify({
    //     prompt: prompt,
    //     max_tokens: 100,
    //     temperature: 0.7,
    //     n: 1,
    //     stop: ['\n']
    //   })
    // });

    //显示iframe
    // setIsTransLate([true, selectString])

    /* onst chatCompletion = await */



    // console?.log(chatCompletion?.data?.choices?.[0]?.message?.content);






    // setTimeout(() => {
    //   // window.open(url, '_blank');
    //   window?.open(
    //     `https://fanyi.sogou.com/text?fr=default&keyword=${selectString}&transfrom=auto&transto=en&model=general`,
    //     '',
    //     'popup,scrollbars,resizable,toolbar',
    //   )
    // })
    // return
    // } else {


    // }
    // copy(selectString,{
    //   debug:true,
    // })
  }

  // 手指触摸文字选中效果
  // const touchstart = (e: React.TouchEvent<HTMLParagraphElement>) => {
  //   if (window?.getSelection()?.toString()) {

  //     videoNode?.pause()
  //   }
  // }

  // 全屏
  // const fullscren = () => {
  //   if (document?.fullscreenElement === null) {
  //     if (fullSub?.requestFullscreen) {
  //       fullSub?.requestFullscreen();
  //     } else if (fullSub?.webkitRequestFullscreen) {
  //       fullSub?.webkitRequestFullscreen();
  //     }
  //     // fullSub?.requestFullscreen()
  //   } else {
  //     document?.exitFullscreen()
  //   }
  // }

  //字幕加载事件
  const onLoadedData = (e: any) => {

    const { text0Show, text1Show } = subHidenType

    const cues: VTTCue[] = e?.target?.track?.cues
    const subArr: any[] = []
    const arrCues: number = cues?.length
    if (arrCues) {
      for (let index = 0; index < arrCues; index++) {
        const element = cues?.[index];
        if (element) {
          element.id = `${index}`
          subArr?.push({
            align: element?.align,//"center",
            endTime: element?.endTime,//18.27,
            id: element?.id,//"0",
            line: element?.line,//"auto",
            pauseOnExit: element?.pauseOnExit,//false,
            position: element?.position,//"auto",
            size: element?.size,//100,
            snapToLines: element?.snapToLines,//true,
            startTime: element?.startTime,//15.68,
            text: element?.text,//"我叫玛丽·艾莉丝·杨\nMy name is Mary Alice Young.",
            text0: element?.text?.split('\n')?.[0],//"我叫玛丽·艾莉丝·杨",
            // text0: (element?.text?.includes('\n') && subHidenType?.type !=='5') ? element?.text?.split('\n')?.[0] : element?.text,//"我叫玛丽·艾莉丝·杨",
            text0Show: text0Show,
            text1: element?.text?.split('\n')?.[1],//"My name is Mary Alice Young.",
            // text1: (element?.text?.includes('\n') && subHidenType?.type !=='5') ? element?.text?.split('\n')?.[1] : element?.text,//"My name is Mary Alice Young.",
            text1Show: text1Show,
          })
        }
      }
    }
    setsubTitlesArr(() => { return [...subArr] })
    syncSubTitlesArr.current = subArr
    setLastPlayPosition()
  }

  // 字幕双击定位事件
  const setSubTitlesLongOnDoubleClickHandle = (e: any, index: string) => {

    // e?.target?.scrollIntoView({
    //   behavior: 'smooth',
    //   block: 'center',
    //   inline: 'center',
    // })
    // 字幕偏移
    if (videoNode?.currentTime) videoNode.currentTime = syncSubTitlesArr.current?.[parseInt(index)]?.startTime - (addTime?.current) + 0.01
    // debugger
    lastPlaybackPosition.current = { ...lastPlaybackPosition?.current, lastPlaySubindex: index }
    // videoNode?.pause()
  }
  // 父组件控制字幕单据循环立即生效
  const singleSentencePatternChangedHandle = (bool: boolean) => {
    // 停止单句循环
    subEndLoop.current = false
    numTimeout.current = null

    // 控制单句暂停
    subEndPlay.current = bool
  }
  // 字幕单击显示事件
  const setSubTitlesLongClickHideHandle = (
    e: React.MouseEvent<HTMLParagraphElement, MouseEvent>,
    index: string,
    subtype: number
  ) => {

    // console.log('!props?.singleSentencePattern :', !props?.singleSentencePattern);
    if (!props?.singleSentencePattern) {
      playIconClick(index)(e)
      return
    }

    //停止单句循环
    subEndLoop.current = false
    numTimeout.current = null

    subEndPlay.current = true
    if (window?.getSelection()?.toString()) {

      videoNode?.pause()
      return
    }

    const subType = subHidenType?.type
    if (
      (subType === '1' && subtype === 0) ||
      (subType === '2' && subtype === 1) ||
      subType === '3'
    ) {
      setSubTitlesLongOnDoubleClickHandle(e, index)
      if (window?.getSelection()?.toString()) {

        videoNode?.pause()
        return
      }
      videoNode?.play()
      return
    }

    videoNode?.pause()
    setsubTitlesArr([...subTitlesArr?.map(v => {
      return {
        align: v?.align,//"center",
        endTime: v?.endTime,//18.27,
        id: v?.id,//"0",
        line: v?.line,//"auto",
        pauseOnExit: v?.pauseOnExit,//false,
        position: v?.position,//"auto",
        size: v?.size,//100,
        snapToLines: v?.snapToLines,//true,
        startTime: v?.startTime,//15.68,
        text: v?.text,//"我叫玛丽·艾莉丝·杨\nMy name is Mary Alice Young.",
        text0: v?.text0, // v?.text?.includes('\n') ? v?.text?.split('\n')?.[0] : v?.text,//"我叫玛丽·艾莉丝·杨",
        text0Show: (subtype === 0 && index === v?.id) ? !(v?.text0Show) : v?.text0Show,
        text1: v?.text1, // v?.text?.includes('\n') ? v?.text?.split('\n')?.[1] : v?.text,//"My name is Mary Alice Young.",
        text1Show: (subtype === 1 && index === v?.id) ? !(v?.text1Show) : v?.text1Show,
      }
    })])
  }
  // 文件上传监听
  // let transcode = async ({ target: { files } }: React.ChangeEvent<HTMLInputElement>) => {
  //   let resultFile = (files as FileList)[0]
  //   if (resultFile) {
  //     let reader = new FileReader();
  //     //异步方式，不会影响主线程
  //     reader?.readAsText(resultFile, 'utf-8');

  //     reader.onload = function (e) {
  //       let urlData = this?.result;
  //       // setMessage(message += urlData)

  //     };
  //   }
  // }
  // gpt输入框
  const gptkeyInputChange = ({ chatGptApiKey }: any) => {
    // form.validateFields()?.then(() => {
    globalChatGptApiKey = lastPlaybackPosition.current.chatGptApiKey = chatGptApiKey
    changeGptkeyValue(chatGptApiKey || '')
    // })?.catch((error) => {
    // messageApi?.error(error)
    // })
  }
  //当前活跃字幕id
  const [activeSub, setActiveSub] = useState('0');
  //字幕类型管理
  const [subHidenType, setIsSubHidenType] = useState({
    text0Show: true,
    text1Show: true,
    type: '3'
  });

  // 显示哪种字幕
  const handleChange = (value: any) => {
    setSelectValue(value)
    lastPlaybackPosition.current.subTitleSowModel = value
    // const { text0Show, text1Show } = subHidenType
    let subHidenTypeTemp = {
      text0Show: true,
      text1Show: false,
      type: '1'
    }
    switch (value?.target.value) {
      case '1':

        setIsSubHidenType({
          text0Show: true,
          text1Show: false,
          type: value?.target?.value
        })
        subHidenTypeTemp = {
          text0Show: true,
          text1Show: false,
          type: value?.target?.value
        }
        break;
      case '2':

        setIsSubHidenType({
          text0Show: false,
          text1Show: true,
          type: value?.target?.value
        })
        subHidenTypeTemp = {
          text0Show: false,
          text1Show: true,
          type: value?.target?.value
        }
        break;
      case '3':

        setIsSubHidenType({
          text0Show: true,
          text1Show: true,
          type: value?.target?.value
        })
        subHidenTypeTemp = {
          text0Show: true,
          text1Show: true,
          type: value?.target?.value
        }
        break;
      case '4':

        setIsSubHidenType({
          text0Show: false,
          text1Show: false,
          type: value?.target?.value
        })
        subHidenTypeTemp = {
          text0Show: false,
          text1Show: false,
          type: value?.target?.value
        }
        break;

      default:
        break;
    }
    const { text0Show, text1Show } = subHidenTypeTemp
    lastPlaybackPosition.current = { ...lastPlaybackPosition?.current, subTitleSowModel: subHidenTypeTemp?.type }
    console.log('字幕模式改变 :', lastPlaybackPosition.current);

    setsubTitlesArr([...subTitlesArr?.map(v => {
      return {
        align: v?.align,//"center",
        endTime: v?.endTime,//18.27,
        id: v?.id,//"0",
        line: v?.line,//"auto",
        pauseOnExit: v?.pauseOnExit,//false,
        position: v?.position,//"auto",
        size: v?.size,//100,
        snapToLines: v?.snapToLines,//true,
        startTime: v?.startTime,//15.68,
        text: v?.text,//"我叫玛丽·艾莉丝·杨\nMy name is Mary Alice Young.",
        text0: v?.text0, // v?.text?.includes('\n') ? v?.text?.split('\n')?.[0] : v?.text,//"我叫玛丽·艾莉丝·杨",
        text0Show: text0Show,
        text1: v?.text1, // v?.text?.includes('\n') ? v?.text?.split('\n')?.[1] : v?.text,//"My name is Mary Alice Young.",
        text1Show: text1Show,
      }
    })])
  };

  //弹框管理
  const [isModalOpen, setIsModalOpen] = useState(false);


  //弹框控制
  const showModal = () => {
    if (!isModalOpen) {

      setIsModalOpen(true);

      //停止单句循环
      subEndLoop.current = false
      numTimeout.current = null
    } else {
      setIsModalOpen(false);

    }
  };

  // const handleOk = () => {
  //   setIsModalOpen(false);
  // };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  //视频路径
  const [videoSrc, setVideoSrc] = useState('');

  // 本地记录播放时间
  const lastPlaybackPosition = useRef<LastPlaybackPositionTYPE>({
    videoName: '',
    subName: '',
    lastPlaySubindex: '',
    subTitleSowModel: '',
    chatGptApiKey: '',
    addTime: 0,
  });

  const onVideoCanPlayThrough = () => {
    setLastPlayPosition()
    setIsVideoPlaying(false)
    props?.changeIsVideoPlaying(false)
  }

  const [gptkeyValue, changeGptkeyValue] = useState('')

  const setLastPlayPosition = () => {
    const { videoName, subName } = lastPlaybackPosition?.current
    if (videoName && subName) {
      const lastPlaybackPositionData = window?.localStorage?.getItem(`${videoName}-${subName}`) as string
      console.log('localStorage获取播放进度数据 :', lastPlaybackPositionData, activeSub);
      const obj: LastPlaybackPositionTYPE = JSON?.parse(lastPlaybackPositionData)
      if (obj) {

        if (Object?.prototype?.hasOwnProperty?.call(obj, 'videoName')) lastPlaybackPosition.current = obj
        if (Object?.prototype?.hasOwnProperty?.call(obj, 'chatGptApiKey') && obj?.chatGptApiKey) {
          globalChatGptApiKey = obj?.chatGptApiKey || ''
          changeGptkeyValue(obj?.chatGptApiKey || '')
        }
        // 非受控组件
        if (Object?.prototype?.hasOwnProperty?.call(obj, 'subTitleSowModel')) setSelectValue(obj?.subTitleSowModel)
        // selectRef.current.state.value = obj?.subTitleSowModel

        if (Object?.prototype?.hasOwnProperty?.call(obj, 'addTime')) addTime.current = obj?.addTime ?? 0
        // 字幕偏移
        if (Object?.prototype?.hasOwnProperty?.call(obj, 'lastPlaySubindex')) videoNode.currentTime = syncSubTitlesArr?.current?.[parseInt(obj?.lastPlaySubindex || '0')]?.startTime - (addTime?.current) + 0.01
      }
    }
  }

  const hploadHandleChange = (e: any) => {
    const file = e.target.files[0];
    lastPlaybackPosition.current = { ...lastPlaybackPosition?.current, videoName: file?.name }
    if (!file) return;
    setVideoSrc(URL.createObjectURL(file));
    // setVideoSrc(window.URL.createObjectURL(e?.file?.originFileObj))
    // setVideoSrc(e?.file)
  }



  //字幕路径
  const [subSrc, setSubSrc] = useState('');
  const subLoadHandleChange = (e: any) => {
    const file = e.target.files[0];
    lastPlaybackPosition.current = { ...lastPlaybackPosition?.current, subName: file?.name }
    if (!file) return;
    setSubSrc(URL.createObjectURL(file));
  }

  // 视频字幕选择好以后
  useEffect(() => {
    videoNode?.load();
    if (isModalOpen && videoSrc && subSrc) {
      setIsModalOpen(false);
      console.log('subTitlesLong :', subTitlesLong?.clientHeight, videoNode?.clientHeight, videoNode?.clientHeight / subTitlesLong?.clientHeight * 100);

      // 横屏
      if (subTitlesLong?.clientHeight === videoNode?.clientHeight) {

        setMaskPercent(50)
      } else {

        setMaskPercent(videoNode?.clientHeight / subTitlesLong?.clientHeight * 100)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoSrc, subSrc]);

  //时间线
  const [videoTimeLine, setvideoTimeLine] = useState(0);

  // 时间纠正
  // const [addTime, setState_addTime] = useState<number>(0) 
  const addTime = useRef<number>(0)
  // 上次播放秒
  let [preSecondInt] = useState<number>(-1) // -1
  // 上次字幕小标
  let [preSubIndex] = useState<number>(-1) // -1
  // 时间线事件
  const onVideoTimeUpdate = (e: any) => {
    e.stopPropagation();
    const videoEle = e?.target
    // 字幕偏移
    const currentTime = videoEle?.currentTime + addTime?.current
    const cues = videoEle?.textTracks[0]?.cues

    // 节流每秒执行
    if (
      videoEle?.textTracks[0]?.cues?.length &&
      preSecondInt !== parseInt(videoEle?.currentTime)
    ) {
      // clog('数组有长度');
      for (let i = 0; i < cues.length; i++) {
        const item = cues[i]
        // console.log('debugger :', item?.startTime, currentTime, item?.endTime);
        const right = (item?.startTime <= currentTime) && (item?.endTime >= currentTime)
        // 不是同一字幕才执行
        if (right) {
          if (preSubIndex !== i) {
            // clog('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^')
            // console.log('当前时间 :', item?.startTime, currentTime, item?.endTime);
            // console.log('当前时间秒 :', preSecondInt, parseInt(videoEle?.currentTime));
            // console.log('当前字幕下标 :', preSubIndex, i);



            // 字幕单句暂停
            if (subEndPlay?.current /* && !e?.currentTarget?.activeCues?.length */) {
              videoNode?.pause()

              if (subEndLoop.current) {
                if (numTimeout?.current) window.clearTimeout(numTimeout?.current)
                // eslint-disable-next-line no-loop-func
                numTimeout.current = setTimeout(() => {
                  setSubTitlesLongOnDoubleClickHandle(null, lastPlaybackPosition?.current?.lastPlaySubindex)
                  // eslint-disable-next-line @typescript-eslint/no-unused-vars
                  let timeNum: NodeJS.Timer | null = setTimeout(() => {
                    videoNode?.play()
                    if (timeNum) clearTimeout(timeNum)
                  }, 0)
                }, 2000)
              }
            }
            const activeCuesIndex: string = `${i}` /* e?.currentTarget?.activeCues?.[0]?.id */

            // if (e?.currentTarget?.activeCues?.length) {
            // 存储locastronge最新字幕
            setActiveSub(activeCuesIndex)
            activeSubRef.current = activeCuesIndex
            lastPlaybackPosition.current = { ...lastPlaybackPosition?.current, lastPlaySubindex: activeCuesIndex }
            // }

            // 滚动字幕
            let index = parseInt(activeCuesIndex)
            subTitlesLong?.children?.[
              index < syncSubTitlesArr.current?.length - 1 && index >= 1 ?
                window.orientation === 0 || window.orientation === 180 ?
                  index + 1 :
                  index - 1
                :
                index
            ]?.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'center',
            })


            // 上次字幕下标
            preSubIndex = i
          }

          break
        }
      }
    }


    // 上一次时间
    preSecondInt = parseInt(videoEle?.currentTime)

    setvideoTimeLine(Math?.round(videoNode?.currentTime / videoNode?.duration * 100));
  }
  // const onProgressUpdate = (e: any) => {
  // videoNode.currentTime = parseFloat((videoNode?.duration / 100 * e).toFixed(3))
  // setvideoTimeLine(Math?.round(videoNode?.currentTime / videoNode?.duration * 100));
  // }
  // const onProgressFocus = () => {
  //   videoNode?.pause()
  // }

  // const onProgressBlur = () => {
  //   videoNode?.play()
  //   progressRef.value = videoTimeLine
  // }
  // const [guideHiden, setGuideHiden] = useState(false)
  // const showGuide = () => {
  //   if (!guideHiden) {
  //     setGuideHiden(true)
  //   }
  // }



  //字幕切换是否暂停
  const subEndPlay = useRef<Boolean>(false);

  //字幕切换是否循环
  const subEndLoop = useRef<Boolean>(false);

  //字幕切换循环定时器
  const numTimeout = useRef<NodeJS.Timer | null>(null);

  // 快进播放图标
  const playIconClick = (index: string, selectString?: string) => {
    return (e: React.MouseEvent<HTMLParagraphElement, MouseEvent>) => {
      e?.stopPropagation()
      //停止单句循环
      subEndLoop.current = false
      if (numTimeout?.current) clearTimeout(numTimeout?.current)

      subEndPlay.current = false
      if (!selectString) {
        if (index === activeSubRef?.current) {
          if (isVideoPlaying) {

            videoNode?.pause()
          } else {

            videoNode?.play()
          }
        } else {
          setSubTitlesLongOnDoubleClickHandle(e, index)
          videoNode?.play()
        }
      } else {
        setSubTitlesLongOnDoubleClickHandle(e, index)
        navigator?.clipboard?.writeText(selectString)?.then(() => {
          messageApi?.open({
            type: 'success',
            content: '复制句子成功 ' + (selectString),
          });
          videoNode?.pause()
          if (globalChatGptApiKey && selectString && /\s/.test(selectString)) {
            netTranslate(selectString)
          } else {

            openIosUrlSchmae(selectString, 'chatX')
          }
        })?.catch(() => {
        })
      }

    }
  }
  // 循环暂停图标
  // const playLoopIconClick = (index: string) => {
  //   return (e: any) => {
  //     e?.stopPropagation()
  //     subEndPlay.current = true
  //     subEndLoop.current = true
  //     setSubTitlesLongOnDoubleClickHandle(e, index)
  //     videoNode?.play()
  //   }
  // }


  //视频播放状态
  //视频路径
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const handleVideoPlaying = (flag: boolean) => {
    if (flag) {
      setIsVideoPlaying(true)
      props?.changeIsVideoPlaying(true)
      // setIsTransLate([false, ''])
      return
    }
    setIsVideoPlaying(false)
    props?.changeIsVideoPlaying(false)
  }

  // 视频控制
  const handleVideoPlay = (flag: string) => {
    // const lastPlaySubindex = lastPlaybackPosition?.current?.lastPlaySubindex
    const lastPlaySubindex = activeSubRef?.current
    switch (flag) {
      case 'Left': {
        // 字幕偏移
        if (videoNode?.currentTime) videoNode.currentTime = syncSubTitlesArr?.current?.[
          parseInt(lastPlaySubindex) === 0 ? 0 : parseInt(lastPlaySubindex) - 1
        ]?.startTime - (addTime?.current) + 0.01
        videoNode?.play()
        break
      }
      case 'Play': {
        videoNode?.play()
        break
      }
      case 'Pause': {
        videoNode?.pause()
        break
      }
      case 'Right': {
        // 字幕偏移
        if (videoNode?.currentTime) videoNode.currentTime = syncSubTitlesArr?.current?.[
          parseInt(lastPlaySubindex) >= syncSubTitlesArr?.current?.length ?
            syncSubTitlesArr?.current?.length - 1 :
            parseInt(lastPlaySubindex) + 1
        ]?.startTime - (addTime?.current) + 0.01
        videoNode?.play()
        break
      }
      case 'subTitleLeft': {
        // setState_addTime(addTime - 1)
        --addTime.current
        lastPlaybackPosition.current = { ...lastPlaybackPosition?.current, addTime: addTime?.current }

        messageApi?.open({
          type: 'success',
          content: '字幕变慢' + addTime?.current,
        });
        break
      }
      case 'subTitleRight': {
        // setState_addTime(addTime + 1)
        ++addTime.current
        lastPlaybackPosition.current = { ...lastPlaybackPosition?.current, addTime: addTime?.current }

        messageApi?.open({
          type: 'success',
          content: '字幕变快' + addTime?.current,
        });

        break
      }
    }
  }
  // // 选区事件防抖
  // let debunceSelectionchangeTimer = useRef<NodeJS.Timer | null>(setTimeout(() => { }))
  // const copySentence = (e?: any) => {
  //   e?.stopPropagation()
  //   if (debunceSelectionchangeTimer?.current) clearTimeout(debunceSelectionchangeTimer?.current)
  //   debunceSelectionchangeTimer.current = setTimeout(() => {

  //     const selectText = window?.getSelection();
  //     if (selectText && typeof selectText === 'string' && /\s/?.test(selectText)) {
  //       videoNode?.pause()
  //       openIosUrlSchmae(selectText, 'chatX')
  //     }
  //   },1000)
  // }
  // //  选择文本事件
  // document?.addEventListener("selectionchange", copySentence);

  // 当前单词下标
  const [currentWord, setCurrentWord] = useState('')
  // 字幕单词点击
  useEffect(() => {
    let currentWordElement = document?.querySelector(".currentWordClass");
    // console.log('currentWordElement :', currentWordElement, [currentWordElement]);
    let s = window?.getSelection();

    if (s && s?.rangeCount > 0) {
      s?.removeAllRanges();

      let range = document.createRange();
      // const [first, end] = findFirst_EndLetterIndex(currentWordElement?.textContent as string)
      // console.log('first, end :', first, end);
      // if (currentWordElement) {
      //   range.setStart(currentWordElement, first)
      //   range.setEnd(currentWordElement, end)
      // }
      if (currentWordElement) range.selectNode(currentWordElement);
      window?.getSelection()?.removeAllRanges()
      s?.addRange(range);
      // if (globelSelectTimer?.current) window?.clearTimeout(globelSelectTimer?.current)
      // globelSelectTimer.current = setTimeout(() => {
      //   window?.getSelection()?.removeAllRanges()
      // },2000) 
    }

  }, [currentWord])
  // 打开软件
  const openIosUrlSchmae = async (str: string, name: string) => {
    /* await navigator.clipboard.readText() ?? 
      .then(text => {
        console.log(text);
      })
      .catch(err => {
        console.error('无法获取剪贴板内容：', err);
      }); */

    if (!str) return
    const isIOS = /iPad|iPhone|iPod/?.test(navigator?.userAgent)

    if (isIOS) {
      console.log("这是一个iOS设备");
      if (openEudic_Timer?.current) clearTimeout(openEudic_Timer?.current)
      openEudic_Timer.current = setTimeout(() => {
        switch (name) {
          case '欧路词典':

            window?.open(`eudic://dict/${str}`, `${name}`)
            break;
          case 'chatX':
            window?.open(`chatx://conversation?title=翻译&message=“${str}”翻译这句话，并且拆解句子各部分语法结构分析，还有英文简易同义词替换后的例句，用中文回答`, 'chatX')
            break;

        }
      }, 300);
    } else {
      console.log("这不是一个iOS设备");
    }


  }
  // 欧路词典
  const openEudic_Timer = useRef<NodeJS.Timer | null>()
  const wordClickHandle = (e: any, OuterIndex: number, innerIndex: number, num: number) => {
    // 关闭翻译弹框
    // setIsTransLate([false, '', ''])

    e?.stopPropagation()
    videoNode?.pause()
    setCurrentWord(`word${OuterIndex}${innerIndex}${num}`)
    const word = e?.target?.textContent.match(/\b[\w]+\b/)
    // console.log('e: ', e?.target?.textContent);
    // // 翻译弹框
    // handleCopy(word)
    /* if (!isIOSafari()) */ navigator?.clipboard?.writeText(word)?.then(() => {
      // alert('复制成功')
      // console.log('复制成功 ' + word);

      messageApi?.open({
        type: 'success',
        content: '复制成功 ' + word,
      });
      // api.info({
      //   message: `复制成功`,
      //   // description:'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
      //   placement: 'bottom',
      // });
    })?.catch(() => {
      // console.log('复制失败 ' + word);

      // alert('复制失败')
      // messageApi?.open({
      //   type: 'error',
      //   content: '复制失败 ' + word,
      // });
      // api.info({
      //   message: `复制失败`,
      //   // description:'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
      //   placement: 'bottom',
      // });
    })
    // console.log('e: ', [e?.target]);
    // let range = document?.createRange();
    // range?.selectNode(e?.target);
    // window?.getSelection()?.addRange(e?.target.textContent);

    // 滚动字幕
    setSubTitlesLongOnDoubleClickHandle(e, `${OuterIndex}`)
    if (globalChatGptApiKey && word && /\s/.test(word)) {

      netTranslate(word)
    } else {

      // if (openEudic_Timer?.current) clearTimeout(openEudic_Timer?.current)
      // const isIOS = /iPad|iPhone|iPod/?.test(navigator?.userAgent)

      // if (isIOS) {
      //   console.log("这是一个iOS设备");
      //   openEudic_Timer.current = setTimeout(() => {
      //     window?.open(`eudic://dict/${word}`, '欧路词典')
      //   }, 300);
      // } else {
      //   console.log("这不是一个iOS设备");
      // }
      openIosUrlSchmae(word, "欧路词典")
    }


  }
  // 版本时间
  // const time_globel = useRef<string>(new Date().toLocaleString("zh-CN")?.replace(/\s|\W/g, '.')) 
  const SubTitlesLongOnScrollTimer = useRef<NodeJS.Timer | null>(null)
  const SubTitlesLongOnScroll = () => {
    if (isTauching.current) {
      videoNode?.pause()
    }
    // 防抖-
    // setIsTransLate([false, '', ''])
    if (SubTitlesLongOnScrollTimer?.current) clearTimeout(SubTitlesLongOnScrollTimer?.current)
    SubTitlesLongOnScrollTimer.current = setTimeout(() => {
      // 防抖移除选择
      window?.getSelection()?.removeAllRanges()
    }, 1000)
  }
  const isTauching = useRef<boolean>(false)
  const subtitleTouchStart = (e: any) => {
    e?.stopPropagation();
    isTauching.current = true
  }
  const subtitleTouchEnd = (e: any) => {
    e?.stopPropagation();
    isTauching.current = false

  }
  // 将外部需要访问的属性和方法暴露出去
  useImperativeHandle(
    ref,
    () => ({
      isVideoPlaying,
      handleVideoPlay,
      showModal,
      singleSentencePatternChangedHandle,
      subHidenType,
      videoTimeLine,
      maskPercent,
    }),
  )
  // 视频高度
  // const [videoNodeClientHeight, setVideoNodeClientHeight] = useState(0)
  // useEffect(() => {
  //   setVideoNodeClientHeight(videoNode?.clientHeight ?? 0)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [props.screenOrientation])

  // api表单
  const [form] = Form.useForm();
  const [isShowAItranslateContent, setIsShowAItranslateContent] = useState<boolean>(false)
  // 翻译弹框
  const [showAItranslateContent, setShowAItranslateContent] = useState<string>('')
  // 关闭翻译弹框
  const handleCancelAItranslate = () => {
    setIsShowAItranslateContent(false);
  };
  return (
    <div
      ref={SetFullSubRef}
      className='videoBackGrond'
    >
      {showBoard ?
        <Modal className='SpinModal_Style' /* width={80} */ centered={true} open={showBoard} footer={null} closable={false}>
          <Spin spinning={showBoard} tip="等待..." size="small" />
        </Modal>
        :
        null
      }
      <Modal open={isShowAItranslateContent} onOk={handleCancelAItranslate}
        onCancel={handleCancelAItranslate}
      >
        <p className='saveWhiteSpace' /* dangerouslySetInnerHTML={{ __html: showAItranslateContent ?? '' }} */ >{showAItranslateContent}</p>
      </Modal>
      {/* 复制消息弹框 */}
      {contextHolder}
      {/* <div
        style={{
          display: guideHiden ? 'block' : 'none',
          position: 'absolute', width: '95vw', height: '95vh', overflowY: 'scroll', backgroundColor: '#ffffff', zIndex: '3'
        }}
      >
        <Button onClick={() => setGuideHiden(false)} >关闭</Button>
        指南
      </div> */}
      {/* 句子播放模式背景  */}
      {/* <div
        style={{
          position: 'fixed',
          height: '90vh',
          top: '0',
          left: '0',
          width: '2rem',
          backgroundColor: '#00000022',
        }}
      ></div> */}
      {/* <div
        style={{
          position: 'fixed',
          width: '2.25rem',
          height: '90vh',
          top: '0',
          right: '0',
          backgroundColor: '#00000022',
        }}
      ></div> */}
      {/* 滚动字幕 */}
      <div
        ref={setSubTitlesLong}
        className='subTitlesLong'

        onScroll={SubTitlesLongOnScroll}
        // // 按下
        onMouseDown={subtitleTouchStart}
        onTouchStart={subtitleTouchStart}

        // // 抬起
        onMouseUp={subtitleTouchEnd}
        onTouchEnd={subtitleTouchEnd}

        // onClick={() => { setIsTransLate([false, '']) }}
        style={{
          display: subHidenType?.type !== '4' ? 'block' : 'none',
          height: !props?.screenOrientation ? '95vh' : '85vh',
          mask: `linear-gradient(0deg, rgba(0, 0, 0, 0.0) 0%,rgba(0, 0, 0, 0.5) 5%, black ${100 - maskPercent - 10}%, rgba(0, 0, 0, 0.3) ${100 - maskPercent - 5}%,rgba(0, 0, 0, 0.0) ${100 - maskPercent}%)`,
        }}
      >
        <div
          style={{
            height: `${maskPercent}vh`,
          }}
        />
        {/* subBacksize?.height >= subBacksize?.width &&  */subTitlesArr?.map((item: any, index: number) => (
          <div
            className='setSubTitlesLongItems'
            // onDoubleClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => videoNode?.pause() }
            key={item?.id}
          >
            {/*<RightCircleOutlined
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#ffffff44',
                position: 'absolute',
                left: '.25rem',
                height: '100%',
                width: '1.5rem',
                zIndex: '2',
              }}
              onClick={playIconClick(item?.id)}
            />*/}
            <div
              style={{
                display: !props?.screenOrientation ? 'flex' : '',
                // width: '5rem',
                transform: item?.id === activeSubRef?.current ? 'scale(1.4) translateX(15%) ' : '',
              }}
            >
              <div
                style={{
                  marginBottom: !props?.screenOrientation ? '0' : item?.id === activeSubRef?.current ? '0.1rem' : '0.5rem',
                  marginRight: !props?.screenOrientation ? '0.5rem' : '0',
                }}
                className='filterBlur_Style'
                onClick={playIconClick(item?.id, `${item?.text0 ?? ''} ${item?.text1 ?? ''}`)}
              >
                <CopyOutlined className={item?.id === activeSubRef?.current ? 'current_opacity_Style' : 'opacity_Style'} />

              </div>
              <div
                className='filterBlur_Style'
                onClick={playIconClick(item?.id)}
              >
                {
                  item?.id === activeSubRef?.current ?
                    isVideoPlaying ?
                      <PauseCircleOutlined className={item?.id === activeSubRef?.current ? 'current_opacity_Style' : 'opacity_Style'} />
                      :
                      <PlayCircleOutlined className={item?.id === activeSubRef?.current ? 'current_opacity_Style' : 'opacity_Style'} />
                    : <RightOutlined className={item?.id === activeSubRef?.current ? 'current_opacity_Style' : 'opacity_Style'} />
                }
              </div>
            </div>
            {/* <RedoOutlined
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#ffffff44',
                position: 'absolute',
                left: '.25rem',
                height: '100%',
                width: '1.5rem',
                zIndex: '2',
              }}
              onClick={playLoopIconClick(item?.id)}
            /> */}
            <div
              style={{
                width: window.orientation === 0 || window.orientation === 180 ? '76vw' : '50vw',
              }}
              // className='subTitlelineWraper_Style'
            // // // 按下
            // onMouseDown={subtitleTouchStart}
            // onTouchStart={subtitleTouchStart}

            // // // 抬起
            // onMouseUp={subtitleTouchEnd}
            // onTouchEnd={subtitleTouchEnd}
            >
              {/* <span style={{color:'#fff'}} >{ index }</span> */}
              {/* 字幕一 */}
              {item?.text0Show ?
                <p
                  // onClick={
                  //   (e: React.MouseEvent<HTMLParagraphElement, MouseEvent>) => setSubTitlesLongClickHideHandle(e, item?.id, 0)
                  // }
                  style={{
                    display: item?.text0 ? 'flex' : 'none',
                    fontSize: activeSubRef?.current !== item?.id ? '1.2rem' : '1.5rem',
                    opacity: activeSubRef?.current !== item?.id ? 0.5 : 1,
                    textShadow: activeSubRef?.current !== item?.id && index >= parseInt(activeSubRef?.current) ?
                      thinSubTitleline?.current
                      :
                      wideSubTitleline?.current,
                  }}
                  className='subTitleline_Style'
                >
                  {/* &ensp; */}{item?.text0?.split(/\s/)?.map((v: string, i: number) => {
                    if (/[^\w\s]+/g?.test(v)) {
                      return (
                        <Fragment key={`word${index}${i}1`}>{
                          /[^\w\s]+/g?.test(v?.[0]) ?
                            <Fragment>
                              <span>{v?.match(/[^\w\s]+/g)?.[0]}</span>
                              <span
                                className={`${currentWord === `word${index}${i}1` ? 'currentWordClass' : ''} subTitleBackgroundBlur`}
                                onClick={(e: any) => { wordClickHandle(e, index, i, 1) }}
                              // 抬起
                              // onMouseUp={() => { handleCopy() }}
                              // onTouchEnd={() => { handleCopy() }}
                              >
                                {v?.replace(/[^\w\s]+/g, '')}
                              </span>
                              <span>{/* &thinsp; */}&nbsp;</span>
                            </Fragment>
                            :
                            <Fragment>
                              <span
                                key={`word${index}${i}1`}
                                className={`${currentWord === `word${index}${i}1` ? 'currentWordClass' : ''} subTitleBackgroundBlur`}
                                onClick={(e: any) => { wordClickHandle(e, index, i, 1) }}
                              // 抬起
                              // onMouseUp={() => { handleCopy() }}
                              // onTouchEnd={() => { handleCopy() }}
                              >
                                {v?.replace(/[^\w\s]+/g, '')}
                              </span>
                              <span>{v?.match(/[^\w\s]+/g)?.[0]}</span>
                              <span>{/* &thinsp; */}&nbsp;</span>
                            </Fragment>
                        }</Fragment>
                      )
                    } else {
                      return (
                        <Fragment key={`word${index}${i}1`}>
                          <span
                            className={`${currentWord === `word${index}${i}1` ? 'currentWordClass' : ''} subTitleBackgroundBlur`}
                            onClick={(e: any) => { wordClickHandle(e, index, i, 1) }}
                          // 抬起
                          // onMouseUp={() => { handleCopy() }}
                          // onTouchEnd={() => { handleCopy() }}
                          >
                            {v}
                          </span>
                          <span>{/* &thinsp; */}&nbsp;</span>
                        </Fragment>
                      )
                    }
                  })}{/* &ensp; */}
                </p>
                :
                <p
                  onClick={
                    (e: React.MouseEvent<HTMLParagraphElement, MouseEvent>) => setSubTitlesLongClickHideHandle(e, item?.id, 0)
                  }
                  className='SubtitlePrompts_Style'
                >
                  {/* &ensp; */}点击展示字幕{/* &ensp; */}
                </p>
              }

              {/* 字幕二 */}
              {item?.text1Show ?
                <p
                  // onClick={
                  //   (e: React.MouseEvent<HTMLParagraphElement, MouseEvent>) => setSubTitlesLongClickHideHandle(e, item?.id, 1)
                  // }
                  style={{
                    display: item?.text1 ? 'flex' : 'none',
                    fontSize: activeSubRef?.current !== item?.id ? '1.2rem' : '1.5rem',
                    opacity: activeSubRef?.current !== item?.id ? 0.5 : 1,
                    textShadow: activeSubRef?.current !== item?.id && index >= parseInt(activeSubRef?.current) ?
                      thinSubTitleline?.current
                      :
                      wideSubTitleline?.current,
                  }}
                  className='subTitleline_Style'
                >
                  {/* &ensp; */}{item?.text1?.split(' ')?.map((v: string, i: number) => {
                    if (/[^\w\s]+/g?.test(v)) {
                      return (
                        <Fragment key={`word${index}${i}2`}>
                          {
                            /[^\w\s]+/g?.test(v?.[0]) ?
                              <Fragment>
                                <span>{v?.match(/[^\w\s]+/g)?.[0]}</span>
                                <span
                                  className={`${currentWord === `word${index}${i}2` ? 'currentWordClass' : ''} subTitleBackgroundBlur`}
                                  onClick={(e: any) => { wordClickHandle(e, index, i, 2) }}
                                // 抬起
                                // onMouseUp={() => { handleCopy() }}
                                // onTouchEnd={() => { handleCopy() }}
                                >
                                  {v?.replace(/[^\w\s]+/g, '')}
                                </span>
                                <span>{/* &thinsp; */}&nbsp;</span>
                              </Fragment>
                              :
                              <Fragment>
                                <span
                                  key={`word${index}${i}2`}
                                  className={`${currentWord === `word${index}${i}2` ? 'currentWordClass' : ''} subTitleBackgroundBlur`}
                                  onClick={(e: any) => { wordClickHandle(e, index, i, 2) }}
                                // 抬起
                                // onMouseUp={() => { handleCopy() }}
                                // onTouchEnd={() => { handleCopy() }}
                                >
                                  {v?.replace(/[^\w\s]+/g, '')}
                                </span>
                                <span>{v?.match(/[^\w\s]+/g)?.[0]}</span>
                                <span>{/* &thinsp; */}&nbsp;</span>
                              </Fragment>
                          }
                        </Fragment>
                      )
                    } else {
                      return (
                        <Fragment key={`word${index}${i}2`}>
                          <span
                            className={`${currentWord === `word${index}${i}2` ? 'currentWordClass' : ''} subTitleBackgroundBlur`}
                            onClick={(e: any) => { wordClickHandle(e, index, i, 2) }}
                          // 抬起
                          // onMouseUp={() => { handleCopy() }}
                          // onTouchEnd={() => { handleCopy() }}
                          >
                            {v}</span>
                          <span>{/* &thinsp; */}&nbsp;</span>

                        </Fragment>
                      )
                    }
                  })}{/* &ensp; */}
                </p>
                :
                subHidenType?.type !== '3' ?
                  <p
                    onClick={
                      (e: React.MouseEvent<HTMLParagraphElement, MouseEvent>) => setSubTitlesLongClickHideHandle(e, item?.id, 1)
                    }
                    className='SubtitlePrompts_Style'
                  >
                    {/* &ensp; */}点击展示字幕{/* &ensp; */}
                  </p>
                  : ''
              }{/**/}
            </div>

            {
              !props?.screenOrientation ?
                <div
                  style={{
                    display: !props?.screenOrientation ? 'flex' : '',
                    // width: '5rem',
                    transform: item?.id === activeSubRef?.current ? 'scale(1.4) translateX(-15%)' : '',
                  }}
                >
                  <div
                    style={{
                      marginBottom: !props?.screenOrientation ? '0' : item?.id === activeSubRef?.current ? '0.1rem' : '0.5rem',
                      marginRight: !props?.screenOrientation ? '0.5rem' : '0',

                    }}
                    className='filterBlur_Style'
                    onClick={playIconClick(item?.id)}

                  >
                    {
                      item?.id === activeSubRef?.current ?
                        isVideoPlaying ?
                          <PauseCircleOutlined className={item?.id === activeSubRef?.current ? 'current_opacity_Style' : 'opacity_Style'} />
                          :
                          <PlayCircleOutlined className={item?.id === activeSubRef?.current ? 'current_opacity_Style' : 'opacity_Style'} />
                        : <RightOutlined className={item?.id === activeSubRef?.current ? 'current_opacity_Style' : 'opacity_Style'} />
                    }

                  </div>
                  <div
                    className='filterBlur_Style'
                    onClick={playIconClick(item?.id, `${item?.text0 ?? ''} ${item?.text1 ?? ''}`)}

                  >
                    <CopyOutlined className={item?.id === activeSubRef?.current ? 'current_opacity_Style' : 'opacity_Style'} />
                  </div>
                </div>
                :
                <div
                  style={{
                    display: !props?.screenOrientation ? 'flex' : '',
                    // width: '5rem',
                    transform: item?.id === activeSubRef?.current ? 'scale(1.4) translateX(-15%)' : '',
                  }}
                >
                  <div
                    style={{
                      marginBottom: !props?.screenOrientation ? '0' : item?.id === activeSubRef?.current ? '0.1rem' : '0.5rem',
                      marginRight: !props?.screenOrientation ? '0.5rem' : '0',

                    }}
                    className='filterBlur_Style'
                    onClick={playIconClick(item?.id, `${item?.text0 ?? ''} ${item?.text1 ?? ''}`)}
                  >
                    <CopyOutlined className={item?.id === activeSubRef?.current ? 'current_opacity_Style' : 'opacity_Style'} />

                  </div>
                  <div
                    className='filterBlur_Style'
                    onClick={playIconClick(item?.id)}
                  >
                    {
                      item?.id === activeSubRef?.current ?
                        isVideoPlaying ?
                          <PauseCircleOutlined className={item?.id === activeSubRef?.current ? 'current_opacity_Style' : 'opacity_Style'} />
                          :
                          <PlayCircleOutlined className={item?.id === activeSubRef?.current ? 'current_opacity_Style' : 'opacity_Style'} />
                        : <RightOutlined className={item?.id === activeSubRef?.current ? 'current_opacity_Style' : 'opacity_Style'} />
                    }
                  </div>
                </div>
            }
          </div>
        ))}
        <div
          style={{
            height: `${maskPercent}vh`,
          }}
        />
      </div>
      {/* <div
          style={{
            display: subHidenType?.type !== '4' ? 'block' : 'none',
            // justifyContent: 'center',
            position: 'absolute',
            width: '100%',
            height: '100%',
          }}
        > */}
      {/* ios safari 滚动条背景 */}
      {/* <div
        style={{
          display: subHidenType?.type !== '4' ? 'block' : 'none',
          position: 'fixed',
          width: '.4rem',
          height: '85vh',
          top: 0,
          right: 0,
          margin: ' 0 .1rem 0 0',
          backgroundColor: '#ffffff33',
          borderRadius: '.2rem',
        }}
      /> */}
      {/* </div>  */}
      {/* <div
        style={{
          display: subHidenType?.type !== '4' ? 'flex' : 'none',
          justifyContent: 'center',
          position: 'absolute',
          width: '100%',
          height: '100vh',
        }}
      > */}
      {/* 播放按键 */}
      {/*<div style={{
        position: 'absolute',
        width: '75vw',
        // height: '4.5rem',
        bottom: '0',
        backgroundColor: '#00000022',
        zIndex: '3',
        marginBottom: '1.5rem',
        color: '#ffffff44',
        borderRadius: '1rem',
        padding: '.5rem 1rem 0 1rem',
        display: 'flex',
        justifyContent: 'space-between',
      }} >
        /~ <Slider className='progress' defaultValue={0} onChange={onProgressUpdate} /> ~/
        /~ <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            // margin: '.5rem 0'
          }}
        > ~/
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '.5rem', width: '2rem', height: '2rem'
        }}></div>
        <div
          style={{
            display: 'flex',
            width: '12rem',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '.5rem',
            fontSize: '2rem',
          }}
        >
          <CaretLeftFilled onClick={() => handleVideoPlay('Left')} />
          {
            isVideoPlaying ? <PauseCircleFilled onClick={() => handleVideoPlay('Pause')} /> : <PlayCircleFilled onClick={() => handleVideoPlay('Play')} />
          }
          <CaretRightFilled onClick={() => handleVideoPlay('Right')} />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '.5rem',
            // display: 'flex',
            // justifyContent: 'space-between',
            // alignItems: 'center',
            // padding: '.5rem',
            width: '2rem',
            height: '2rem'
            // fontSize:'2rem',
          }}
        >
          <MenuFoldOutlined onClick={showModal} />
        </div>
        /~ </div> ~/
      </div>*/}
      {/* </div> */}
      {/* {videoTimeLine} */}
      <Progress className='progress'
        style={{
          display: subHidenType?.type === '4' ? 'none' : 'block',
        }}
        percent={videoTimeLine}
        showInfo={false}
      />
      {/* <input ref={setProgressRef} className='progress' style={{ position: 'absolute', left: '1vw', bottom: '0', width: '98vw', zIndex: '1' }} defaultValue={0} type="range" min="0" max="100" onChange={onProgressUpdate} step="1" onFocus={onProgressFocus} onBlur={onProgressBlur} /> */}

      {/* 字幕 */}
      {/* <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
            <p onTouchEnd={touchstart} onMouseUp={handleCopy} dangerouslySetInnerHTML={{ __html: subTitles ?? '' }} className='overlay' style={{ top: `${Math?.round(subTitlesPosition/16)}rem` }} ></p>
          </div> */}

      {/* <p onMouseUp={handleCopy}  >qw</p> */}
      {/* 视频播放 */}
      <div
        className='videoPositionWapper'

      >
        <div className="videoWapper">
          <video
            // controlsList='nodownload noremoteplayback nofullscreen'
            // autopictureinpicture={true}
            onTimeUpdate={onVideoTimeUpdate}
            style={{
              //   width: (videosize?.width ?? '100vw') + '!important',
              //   height: (videosize?.height  ?? '90vh') + '!important',
              //   // height: '90vh !important',
              maxHeight: !props?.screenOrientation ? '95vh' : '85vh',
              zIndex: 2,
              // zIndex: subBacksize?.height > subBacksize?.width ? '4' : '0',
            }}
            // width={videosize?.width}
            // height={videosize?.height}
            // onResize={videoonResizeHandle}
            className='video'
            ref={SetvideoRef}
            // controls
            // webkit-playsinline={true}
            playsInline={true}
            controls={subHidenType?.type === '4'}
            onLoadedData={onVideoCanPlayThrough}
            onPlaying={() => handleVideoPlaying(true)}
            onPause={() => handleVideoPlaying(false)}
          >
            {/* kind="captions" */}
            <track
              ref={setTextTrackRef}
              onLoadCapture={onLoadedData}
              srcLang='zh/en'
              kind="subtitles"
              label="zh/en"
              default
              src={subSrc}
            // src={require('../../assets/video/S1～01.vtt')}
            // src={textTrackPath}
            />
            {/* <source src='https://media.w3.org/2010/05/sintel/trailer.mp4' type="video/mp4"></source> */}
            <source
              src={videoSrc}
              // src={require('../../assets/video/S1～01.mp4')}
              type="video/mp4"
            ></source>
            {/* <source src={videoPath} type="video/mp4"></source> */}
          </video>
          <div className='videoSubtitleMask'
            style={{
              height:
                subBacksize?.height ?
                  Math?.round(subBacksize?.height * 0.2 * 10) / 10 + 'px'
                  :
                  '5rem',
            }}
          ></div>
        </div>
      </div>

      {/*      <Button
        style={{
          position: 'absolute',
          // bottom: `${Math?.round((subBacksize?.height + 70) / 2 / 16)}rem`,
          bottom: `9rem`,
          right: Math?.round(30 / 16) + 'rem',
          zIndex: '1'
        }}
        onClick={fullscren} icon={<ExpandOutlined />}>
        /~ 全屏 ~/
      </Button>*/}
      {/* <MenuFoldOutlined
        onClick={showModal}
        style={{
          position: 'absolute',
          color: '#ffffffaa',
          // bottom: `${Math?.round((subBacksize?.height + 70) / 2 / 16)}rem`,
          bottom: `2rem`,
          right: Math?.round(16 / 16) + 'rem',
          zIndex: '1'
        }}
      /> */}
      {/*<Button
        onClick={showModal}
        style={{
          display: subHidenType?.type === '4' ? 'block' : 'none',
          position: 'absolute',
          // bottom: `${Math?.round((subBacksize?.height + 70) / 2 / 16)}rem`,
          bottom: `6rem`,
          right: Math?.round(30 / 16) + 'rem',
          zIndex: '1'
        }}
        icon={<MenuFoldOutlined />}
      >
        /~ /~ 设置 ~/ ~/
      </Button>*/}
      {/* <MenuFoldOutlined
        onClick={showModal}
        style={{
          display: subHidenType?.type === '4' ? 'block' : 'none',
          position: 'absolute',
          color: '#ffffffaa',
          // bottom: `${Math?.round((subBacksize?.height + 70) / 2 / 16)}rem`,
          bottom: `2rem`,
          right: Math?.round(16 / 16) + 'rem',
          zIndex: '1'
        }}
      /> */}



      {/* 设置弹框 */}
      <Modal
        centered={true}
        // title={`设置(版本-${time_globel})`}
        // title={`设置,${Math?.round(subBacksize?.height * 10) / 10},${Math?.round(videoNodeClientHeight * 10) / 10}`}
        title={`设置${''}`}
        open={isModalOpen}
        onOk={handleCancel}
        onCancel={handleCancel}
      // open={isModalOpen} onOk={handleOk} onCancel={handleCancel}

      // className='Modal'
      // style={{
      //   display: isModalOpen ? 'block' : 'none',
      //   // top: '2rem',//`${Math?.round((subBacksize?.height / 2 - 168) / 16)}rem`,
      //   // left: `${Math?.round((subBacksize?.width / 2 - 160) / 16)}rem`,
      //   color: 'black'
      // }}
      >
        {/* <div style={{ height: Math?.round(20 / 16) + 'rem' }} /> */}
        {/* <Row>
          <Col span={24}>
            <Button onClick={fullscren}>全屏</Button>
          </Col >
        </Row> */}

        <Row justify="center">
          <Col span={24}>
            {/* <span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => { showGuide() }}>查看使用指南</span> */}
            <a href='https://support.qq.com/product/624652' target="意见反馈">意见反馈</a>
            <br />
            <span className='buttonLine_Style'>
              iphone设备, chatX App 新建名为“翻译”的会话, 推荐把网页发送到主屏幕.

            </span>
            <br />
            <span className='buttonLine_Style'>如果视频一直不播放呈现灰色, 可以重新打开safari浏览器, 再切换回来, 或者重启手机</span>
            {/* <br />
            <span className='buttonLine_Style'>或者重启手机</span> */}
          </Col >
        </Row>


        {/* <div style={{ height: Math?.round(15 / 16) + 'rem' }} /> */}
        <Divider />
        <Row justify="center" align='middle'>
          <Col span={24}>
            双语字幕显示模式：
            {/* <Select
              defaultValue="双语字幕"
              style={{ width: 120 }}
              onChange={handleChange}
              options={[
                { value: '1', label: '字幕1点击展示' },
                { value: '2', label: '字幕2点击展示' },
                { value: '3', label: '双语字幕' },
                { value: '4', label: '无', },
              ]}
            /> */}
            <select
              // value={selectValue}
              ref={setSelectRef}
              className='selectSub'
              onChange={handleChange}
              // onClick={handleChange}
              defaultValue={lastPlaybackPosition?.current?.subTitleSowModel || subHidenType?.type}>
              <option value="1">第一行</option>
              <option value="2">第二行</option>
              <option value="3">两&nbsp;&nbsp;&nbsp;&nbsp;行</option>
              <option value="4">无-盲听</option>
              {/* <option value="5">单语字幕</option> */}
            </select>
          </Col >
        </Row>
        <div style={{ height: Math?.round(10 / 16) + 'rem' }} />
        <span className='buttonLine_Style'>选择本地字幕(.vtt)</span><br></br>
        <Row justify='center'>
          <input
            className='inputFile'
            type='file'
            // className='form-control form-control-sm'
            // id='media-URL'
            accept='.vtt'
            onChange={(event) => {
              subLoadHandleChange(event);
            }}
          >
            {/* <UploadOutlined className="uploader" /> */}
          </input>
        </Row>
        {/* <Upload  >
              <UploadOutlined className="uploader" />
            </Upload > */}
        {/* <Col span={8}> */}
        {/* </Col > */}
        <p>

          <span>找字幕文件</span><br></br>
          _<a href='https://assrt.net/' target='字幕网'>[射手字幕] </a>_&nbsp;
          _<a href='https://subscene.com/' target='字幕网'>[subscene.com] </a>_&nbsp;
          {/* _<a href='https://www.opensubtitles.org/zh' target='字幕网'>网地址3 </a>_&nbsp; */}
          <br></br>
          <br></br>

          <span>字幕文件转格式{/* -&gt; */} :</span><br></br>
          <span>.srt转为-&gt; :</span><br></br>
          _<a
            href='https://converter.app/cn/srt-vtt/'
            target='转格式'
          > (.vtt)网站0</a>_&nbsp;
          _<a
            href='https://convert.jamack.net/zh/convert/vtt/%E8%AF%B7%E5%85%88%E9%80%89%E6%8B%A9%E5%AD%97%E5%B9%95%E6%96%87%E4%BB%B6%E3%80%82'
            target='转格式'
          > (.vtt)网站1</a>_&nbsp;
          <br></br>
          _<a
            href='https://subtitletools.com/convert-subtitles-to-plain-text-online'
            target='转格式'
          > (.txt)网站2</a>_&nbsp;
          _<a
            href='https://converts.me/tools/conversion/subtitle/srt-to-txt'
            target='转格式'
          > (.txt)网站3</a>_&nbsp;
          <br></br>
          <span>.ass转为-&gt; :</span><br></br>
          _<a
            href='https://converter.app/cn/ass-vtt/'
            target='转格式'
          > (.vtt)网站0</a>_&nbsp;
        </p>
        <Divider />
        {/* <div style={{ height: Math?.round(15 / 16) + 'rem' }} /> */}

        {/* <Row justify="center"> */}
        {/* <Col span={24}> */}
        {/* <Upload
              onChange={hploadHandleChange}
            >
              <UploadOutlined className="uploader" />
            </Upload > */}
        <span className='buttonLine_Style'>选择本地视频(.mp4/.mkv(音频acc))[2G]</span>
        <Row justify='center'>

          <input
            className='inputFile'
            type='file'
            // className='form-control form-control-sm'
            // id='media-URL'
            accept='video/mp4,.mkv'
            onChange={(event) => {
              hploadHandleChange(event);
            }
            }
          >
            {/* <UploadOutlined className="uploader" /> */}

          </input>

        </Row>
        <p>
          "HandBrake"软件可免费转格式
          <br></br>
          或者iphone下载【<a href='https://apps.apple.com/cn/app/stay-for-safari-%E6%B5%8F%E8%A7%88%E5%99%A8%E4%BC%B4%E4%BE%A3/id1591620171'>stay</a>】应用,safari长按视频即可下载网页视频
        </p>
        {/* </Col > */}
        {/* <Col span={24}> */}
        {/* <div style={{ height: Math?.round(16 / 16) + 'rem' }} /> */}
        {/* </Col> */}
        {/* <Col span={24}> */}


        {/* </Col > */}
        {/* </Row> */}
        {/* <div style={{ height: Math?.round(8 / 16) + 'rem' }} /> */}
        {/* <Button type='primary' onClick={handleCancel} >关闭</Button> */}
        <Divider />

        {/* <div style={{ height: Math?.round(10 / 16) + 'rem' }} /> */}


        <Row justify="center">
          <Col span={24}>
            {/* {
              gptkeyValue ?
                // lastPlaybackPosition.current.chatGptApiKey ?
                <Input
                  value={lastPlaybackPosition.current.chatGptApiKey}
                  // onChange={gptkeyInputChange}
                  type="text" placeholder="openAi的API Key 翻译"
                  suffix={<CloseCircleOutlined onClick={() => { globalChatGptApiKey = lastPlaybackPosition.current.chatGptApiKey = ''; changeGptkeyValue('') }} />}
                />
                :
                <Input
                  defaultValue={lastPlaybackPosition.current.chatGptApiKey}
                  onChange={gptkeyInputChange}
                  type="text" placeholder="openAi的API Key 翻译"
                  suffix={<CloseCircleOutlined onClick={() => { globalChatGptApiKey = lastPlaybackPosition.current.chatGptApiKey = ''; changeGptkeyValue('') }} />}
                />
              } */}
            <p>API Key: {gptkeyValue}</p>
            <Form form={form}/* name='chatGptApiKeyform'  */ onValuesChange={gptkeyInputChange}>
              <Form.Item
                // messageVariables={{ label: 'good' }}
                name='chatGptApiKey'
                // label={<span>user</span>}
                rules={[{ pattern: /^sk-[A-Za-z0-9]{40,60}$/, message: '格式错误', validateTrigger: ['onChange', 'onBlur'] }]}
              >
                <Input
                  // defaultValue={lastPlaybackPosition.current.chatGptApiKey}
                  allowClear
                  // onChange={gptkeyInputChange}
                  type="text" placeholder="openAi的API Key 翻译"
                // suffix={<CloseCircleOutlined onClick={() => { globalChatGptApiKey = lastPlaybackPosition.current.chatGptApiKey = ''; changeGptkeyValue('') }} />}
                />
              </Form.Item>
            </Form>
            {/* <p>或选词复制后快捷指令快速打开欧路词典读取剪贴板速查 </p> */}
          </Col >
        </Row>

      </Modal >

    </div >
  );
})

export default PlayVideo;
